import { render, staticRenderFns } from "./selectdc.vue?vue&type=template&id=02b5df86&scoped=true&"
import script from "./selectdc.vue?vue&type=script&lang=js&"
export * from "./selectdc.vue?vue&type=script&lang=js&"
import style0 from "./selectdc.vue?vue&type=style&index=0&id=02b5df86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5df86",
  null
  
)

export default component.exports